import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { ExpensesIcon, InvoiceIcon, LaptopIcon, LogfileIcon, StoreIcon, WarehouseIcon } from '../../atoms/icons'
import { IconHeader } from '../../molecules/Header'

const features = [
    {
        title: "Point Of Sale",
        details: 
        `The Shopkeeper was built purposefully with your shopkeeper in mind. 
        It has a simple point of sale interface that enables your shopkeeper to sell on-the-go with no stress.
        Yeah, like really, no stress even when there is pressure from your customers.`,
        icon: LaptopIcon
    },
    {
        title: "Shop Management",
        details: 
        `Designed with effective management tools. You can perform create and delete operation on 
        your products, employees and shops. You can also assign roles which comes with specific 
        functionalities to your employees. There is more just start with our free 30 day trial.`,
        icon: StoreIcon
    },
    {
        title: "Inventory management",
        details: 
        `Keep track of each product in your store, it's sales history, market performance, etc.
        Get summarized and comprehensive reports so you see what's selling and
        what's not. These reports enable you to stock your inventory with what your customers are sure to purchase.
        No more worrying about expiration dates😊.`,
        icon: WarehouseIcon
    },
    {
        title: "Accounting On Steroids",
        details: 
        `Lorem ipsum dolor sit amet, consectetur adipisicing elit. 
        Debitis veritatis enim sunt! Error itaque nostrum perferendis eaque. 
        Maxime sunt quod repellat voluptatibus, molestias mollitia quis deserunt quasi voluptatem 
        culpa aspernatur sequi, minima, eaque enim maiores?`,
        icon: ExpensesIcon
    },
    {
        title: "Invoice Generation",
        details: "",
        icon: InvoiceIcon
    },
    {
        title: "Activity logging",
        details: `See everything your employees do in the system. From login to signout. Track 
        activites such as sales, product creation, deletion, modification, etc.`,
        icon: LogfileIcon
    }
]

export default function Features() {

    const featuresRef = useRef<HTMLDivElement>(null)
    const currentLocation = useLocation()

    useEffect(()=>{
        if(currentLocation.hash === "#features"){
            featuresRef?.current?.scrollIntoView()
        }
    },[currentLocation.hash])

   

    return (
        <section className='p-12 md:px-0' ref={featuresRef} >

            <div className="text-center leading-9 my-7">
                <h5 className="font-bold text-3xl text-primary">Special features</h5>
                <p className='text-zinc-600 sm:leading-6' >These features are what makes <b><span className="text-primary">The</span> Shopkeeper</b> <span className="w-1 h-1 rounded-full inline-block bg-secondary"/> unique and different</p>
            </div>

            <section className="flex flex-wrap justify-center mt-10 columns-lg' p-5">

                {
                    features.map((feature, index)=>(
                        <div key={index} className="text-md w-1/4 md:w-2/3 sm:w-full text-neutral-700 font-normal p-4 rounded shadow-lg border-secondary2 border mr-12 md:mr-0 mb-20 md:mb-8">
                            <div>
                                <IconHeader 
                                    Icon={feature.icon}
                                    title={feature.title}

                                />
                                <p className='text-sm'>
                                    {
                                        feature.details
                                    }
                                </p>
                            </div>
                        </div>
                    ))
                }

            </section>

        </section>
    )
}
